<template>
  <button class="chess-clock monospace" :class="{'is-active': running, 'is-done': elapsed >= startTime}">
    {{ displayTime }}
  </button>
</template>

<script>
  export default {
    name: 'ChessClock',
    props: {
      startTime: {
        type: Number,
        default: 10
      },
      bonusTime: {
        type: Number,
        default: 0
      },
      running: {
        type: Boolean,
        default: false
      },
      gameStarted: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        elapsed: 0,
        timerId: undefined,
        timerInterval: 100,
        time: undefined
      }
    },
    watch: {
      running(running) {
        if (running)
          this.startTimer();
        else {
          this.elapsed = this.elapsed - this.bonusTime * 10;
          this.updateClock();
          clearTimeout(this.timerId);
        }
      },
      gameStarted (hasStarted) {
        if (!hasStarted) {
          this.elapsed = 0;
          this.updateClock();
        }
      },
      startTime() {
        this.updateClock();
      }
    },
    created() {
      this.time = this.startTime;
    },
    methods: {
      startTimer() {
        var expected = Date.now() + this.timerInterval;
        this.timerId = setTimeout(this.incrementTime, this.timerInterval, expected);
      },
      incrementTime(expected) {
        var drift = Date.now() - expected;
        // if (drift > this.timerInterval) {
        //     // console.log('time is wrong');
        // }
        this.elapsed = this.elapsed + 1;

        this.updateClock();

        expected += this.timerInterval;
        this.timerId = setTimeout(this.incrementTime, Math.max(0, this.timerInterval - drift), expected); 
      },
      updateClock() {
        this.time = Math.max(0, this.startTime - this.elapsed);
      }
    },
    computed: {
      displayTime() {
        const minutes = Math.floor(this.time / 10 / 60);
        const seconds = Math.floor(this.time / 10 % 60) + '';
        return `${minutes}:${seconds.padStart(2, '0')}`;
      }
    }
  }
</script>

<style>
  .chess-clock {
    width: 100%;
    font-size: 15vw;
    background: var(--plum);
    color: var(--cream);
    border: 0;
  }

  .chess-clock[disabled] {
    opacity: 1;
    color: var(--putty);
  }

  .chess-clock.is-active {
    background: var(--active);
  }

  .chess-clock.is-done {
    background: var(--negative);
  }

  .chess-clock--minimized {
    position: absolute;
    transform: scale(.55);
    margin: 1dvh 6px;
    transform-origin: 100% 0;
    z-index: 2;
    top: 0;
    right: 0;
    width: fit-content;
    height: 9dvh;
    border-radius: 6px;
    padding-left: .3em;
    padding-right: .3em;
    font-size: 45px;
  }

  .chess-clock--cramped {
    font-size: 23px;
  }

  .chess-clock--minimized.is-active {
    outline: 1px solid white;
  }

  .chess-clock--minimized.flip {
    transform: scale(-.5);
    margin: -12px -6px;
    top: 100%;
    right: 100%;
  }
</style>